import React, { useContext } from 'react'
import Box from '@material-ui/core/Box'
import isEmpty from 'lodash/isEmpty'

import { RiskProductsContext } from '../../context'
import { ActionablesContext } from '@contexts/ActionablesContext'
import { Grid } from '@components/layout/Grid'
import { Button } from '@components/Button'
import { CardActionButton } from '@components/layout/Card/CardActionButton'
import { Card, CardFooter } from '@components/layout/Card'
import { RiskProductCard } from '@components/RiskProducts/Card'

export const CurrentRiskProductsCards = () => {
  const { state } = useContext(RiskProductsContext)
  const { riskProducts, scenario } = state

  return (
    <Grid mediumColumns>
      <AddRiskProductCard />
      {riskProducts.map((riskProduct, index) =>
        <RiskProductCard
          key={index}
          riskProduct={riskProduct}
          Footer={() =>
            scenario?.id
              ? <RiskProductCardFooter
                index={index}
              />
              : null
          }
        />
      )}
    </Grid>
  )
}

const AddRiskProductCard = () => {
  const { readOnly } = useContext(ActionablesContext)

  return (
    <Card darkBorder className='ui-card--centered-cue-card text-center'>
      {readOnly
        ? <GoToScenarioPlanning />
        : <AddRiskProductsButtons />}
    </Card>
  )
}

const AddRiskProductsButtons = () => {
  const {
    state: { scenario },
    actions: { goToAddRiskProduct }
  } = useContext(RiskProductsContext)

  const scenarioId = scenario?.id

  return (
    <Box m='1rem'>
      <Button disabled={!scenarioId} fullWidth primary onClick={goToAddRiskProduct} trackAs='Add Risk Product card: Add Risk Product'>Add risk product</Button>
      {!scenarioId &&
        <small>Select an individual to add a risk product</small>
      }
    </Box>
  )
}

const GoToScenarioPlanning = () => {
  const { state: { onCreateNewScenario, riskProducts } } = useContext(RiskProductsContext)
  const addRiskProductText = isEmpty(riskProducts) ? 'Want to add a risk product?' : 'Want to add another risk product?'

  return (
    <Box
      display='flex'
      flexDirection='column'
      justifyContent='center'
      alignItems='center'
      mx='2rem'
    >
      <h5>{addRiskProductText}</h5>
      <Button
        primary
        trackAs='Add riskProduct card: New scenario'
        onClick={() => onCreateNewScenario()}
      >
        Create a new scenario
      </Button>
    </Box>
  )
}

const RiskProductCardFooter = ({ index }) => {
  const { actions } = useContext(RiskProductsContext)
  const { readOnly } = useContext(ActionablesContext)
  const { updateRiskProduct, deleteRiskProduct } = actions
  return (
    !readOnly &&
    <CardFooter>
      <CardActionButton icon="trash" label="Delete risk product" trackAs='RiskProduct Card: Delete' className='risk-product-action' onClick={deleteRiskProduct(index)} />
      <CardActionButton icon="pencil" label="Update risk product" trackAs='RiskProduct Card: Update' className='risk-product-action' onClick={updateRiskProduct(index)} />
    </CardFooter>
  )
}
